module.exports = __webpack_public_path__ + "images/ce52cda698a27c90764f452abbde851b.svg";